export const altaEntidades_CountryList = ['AR', 'CL', 'PY'];

export const altaEntidades_domains: { domain: string, subDomain: string, documentVar: string }[] = [
  { domain: 'AR_IDENTITY', subDomain: 'NATURAL_PERSON', documentVar: 'documento_numero' },
  { domain: 'CL_CONSUMER_IDENTITY', subDomain: 'SRCEI_VERIFICATION', documentVar: 'rut' },
  { domain: 'PY_CONSUMER_IDENTITY', subDomain: 'NATURAL_PERSON', documentVar: 'cedula' },
]
